/**
 * Hook for the schedule week endpoint.
 */
import { queryOptions, useQuery } from '@tanstack/react-query';
import type { ScheduleWeekResponse } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

/** Shared query options so a prefetch warms the exact entry the hook reads. */
export function scheduleWeekOptions(start: string, days: number = 7) {
  return queryOptions({
    queryKey: ['schedule', 'week', start, days],
    queryFn: () =>
      apiCall<ScheduleWeekResponse>(`/schedule/week?start=${start}&days=${days}`),
    staleTime: 30_000,
    refetchInterval: 120_000,
  });
}

export function useScheduleWeek(start: string, days: number = 7) {
  return useQuery(scheduleWeekOptions(start, days));
}
